import { render, staticRenderFns } from "./RelatorioBaseContratos.vue?vue&type=template&id=86125998"
import script from "./RelatorioBaseContratos.vue?vue&type=script&lang=js"
export * from "./RelatorioBaseContratos.vue?vue&type=script&lang=js"
import style0 from "./RelatorioBaseContratos.vue?vue&type=style&index=0&id=86125998&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports